// extracted by mini-css-extract-plugin
export default {"container":"RetexDetails_container__fSyGC","row":"RetexDetails_row__-y6Sz"};